import { gql } from "apollo-boost";

export const layoutsVideoQuery = gql`
  query layoutsVideoQuery {
    layoutVideoList {
      id
      id_descritivo
      nome
    }
  }
`;

export const salvarGravacaoVideo = gql`
    mutation ($gravacao_bbb_id: Int!, $sessao_id: Int!, $inicio: String!, $nome: String!, $layout_video_id: Int!, $fl_partes: Int!, $json_partes: String! ) {
      gravacaoVideoSalvar( gravacaoBbbId: $gravacao_bbb_id, sessaoId: $sessao_id, inicio: $inicio, nome: $nome, layoutVideoId: $layout_video_id, flPartes: $fl_partes, jsonPartes: $json_partes )
    }
`;

export const gravacaoVideosQuery = gql`
  query gravacaoVideosQuery($sessao_id: Int!) {
    gravacaoVideosList(sessao_id: $sessao_id) {
      id
      created_at
      updated_at
      gravacao_bbb_id
      sessao_id
      inicio
      nome
      layout_video {
        id
        id_descritivo
        nome
      }
      fl_partes
      json_partes
      fl_processamento_iniciado
      url_video
      publicado
    }
  }
`;

export const gravacaoVideoExclusao = gql`
  mutation gravacaoVideoExclusao($id: Int!){
    excluirGravacaoVideo(id: $id)
  }
`;

export const gravacaoVideoAlteraPublicado = gql`
  mutation ($id: Int!, $publicado: Int!) {
    alteraPublicadoGravacaoVideo(id: $id, publicado: $publicado)
  }
`;
